<template>
    <transition name="sidebar">
        <div v-if="isSidebarOpen" class="overlay" @click="close">
            <tenants v-if="tenants.length > 1" :tenants="tenants" />
            <tenant :tenant="tenant" />
        </div>
    </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { CLOSE_SIDEBAR } from '../../stores/global/mutations'
import Tenant from './Tenant'
import Tenants from './Tenants'

export default {
    name: 'Sidebar',

    components: {
        Tenant,
        Tenants
    },

    props: {
        tenant: {
            type: Object,
            required: true
        },

        tenants: {
            type: Array,
            required: true
        }
    },

    computed: {
        ...mapState(['isSidebarOpen'])
    },

    methods: {
        ...mapMutations({
            close: CLOSE_SIDEBAR
        })
    }
}
</script>

<style scoped lang="less">
    .sidebar,
    .overlay {
        transition: all 0.3s ease-in-out;
    }

    .sidebar-enter, .sidebar-leave-to {
        opacity: 0;

        .sidebar {
            transform: translateX(-100px);
        }
    }
</style>
